const httpUrl = process.env.BASE_API
const globalServices = {
    //--------------------------------
    /*平台用户登录*/
    platformUserLogin: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/platformUserLogin`,
        needToken:true,
    },
    /*平台用户退出登录*/
    userLogOut: {
        method: 'GET',
        url: `${httpUrl}/api/v1/platformBiz/userLogOut`,
        needToken:true,
    },
    /*用户注册*/
    platformUserReg: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/platformUserReg`,
        needToken:true,
    },
    /*查询所有平台用户信息*/
    queryAllPlatformUser: {
        method: 'GET',
        url: `${httpUrl}/api/v1/platformBiz/queryAllPlatformUser`,
        needToken:true,
        needPlatformToken:true,
    },
    /*分页查询视频信息*/
    queryVideoDataByPage: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/queryVideoByPage`,
        needToken:true,
        needPlatformToken:true,
    },
    /*视频转发*/
    transmitVideo: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/transmitVideo`,
        needPlatformToken:true,
    },
    /*视频评论*/
    commentVideo: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/commentVideo`,
        needPlatformToken:true,
    },
    /*查询视频的评论*/
    queryComment: {
        method: 'GET',
        url: `${httpUrl}/api/v1/platformBiz/queryComment`,
        needPlatformToken:true,
    },
    /*视频点赞*/
    videoTag: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/videoTag`,
        needPlatformToken:true,
    },
    /*查询当前用户收到的消息*/
    queryCurrentTransmit: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/queryCurrentTransmit`,
        needPlatformToken:true,
    },
    /*删除视频*/
    deleteVideo: {
        method: 'DELETE',
        url: `${httpUrl}/api/v1/platformBiz/deleteVideo`,
        needPlatformToken:true,
    },
    /*删除转发的视频消息*/
    deleteVideoTransmit: {
        method: 'DELETE',
        url: `${httpUrl}/api/v1/platformBiz/deleteVideoTransmit`,
        needPlatformToken:true,
    },
    /*发布视频*/
    publishVideo: {
        method: 'POST',
        url: `${httpUrl}/api/v1/platformBiz/publishVideo`,
        needPlatformToken:true,
    },
    //--------------------------------
};
export default globalServices;



// WEBPACK FOOTER //
// ./src/services/platform-user/platformApi.js